module.exports = __webpack_public_path__ + "static/assets/1e4e6b0b9b6a2937062103b7d0b03247.png";